import { ChannelLinkForm } from "types/locations";

export const defaultValues: ChannelLinkForm = {
  active: false,
  name: "",
  simphonyRevenuCenterId: "",
};
